import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-substitutionAttachment',
  templateUrl: 'substitutionAttachment.page.html',
  styleUrls: ['substitutionAttachment.page.scss']
})
export class SubstitutionAttachmentPage {

  attachments:any=[];

  constructor(private modalController: ModalController, navParams: NavParams) {
    this.attachments = navParams.get('attachments');
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
